import React from 'react'

import { Link, useLocation, useNavigate } from 'react-router-dom';
import NotificationBell from './NotificationBell.jsx';
// A map to associate category slugs with their Font Awesome icons.
// This is kept in the UI component as it's a presentation concern.
const iconMap = {
    'surface-equipment': 'fas fa-truck',
    'underground-equipment': 'fas fa-hammer',
    'construction-equipment': 'fas fa-hard-hat',
    'ore-sales': 'fas fa-gem',
    'plant': 'fas fa-industry',
    'consumables': 'fas fa-box-open',
    'mines': 'fas fa-mountain',
    'transportation': 'fas fa-truck-moving',
    'rental-equipment': 'fas fa-retweet',
    'refurbishing-services': 'fas fa-wrench',
    'excavator': 'fas fa-cogs',
    'front-end-loader': 'fas fa-truck-loading',
    'dump-truck': 'fas fa-truck-monster',
    'dozer': 'fas fa-snowplow',
    'grader': 'fas fa-road',
    'water-truck': 'fas fa-tint',
    'diesel-truck': 'fas fa-gas-pump',
    'mud-truck': 'fas fa-truck-monster',
    'bobcat': 'fas fa-tractor',
    'tlb': 'fas fa-tractor',
    'adt': 'fas fa-truck-monster',
    'sit-on-broom': 'fas fa-broom',
    'hi-up-truck': 'fas fa-truck-pickup',
    'crane': 'fas fa-angle-double-up',
    'pecker-hammer': 'fas fa-hammer',
    'cherry-picker': 'fas fa-angle-double-up',
    'telehandler': 'fas fa-truck-loading',
    'tyre-grab': 'far fa-dot-circle',
    'mobile-crusher': 'fas fa-recycle',
    'mobile-screen': 'fas fa-filter',
    'drill-rig': 'fas fa-cog',
    'roller': 'fas fa-road',
    'bev': 'fas fa-car-battery',
    'tyres': 'far fa-dot-circle',
    'conveyers': 'fas fa-sliders-h',
    // Underground Equipment
    'loaders': 'fas fa-truck-loading',
    'underground-dump-truck': 'fas fa-truck-monster',
    'underground-grader': 'fas fa-road',
    'scaler': 'fas fa-mountain',
    'bolter': 'fas fa-thumbtack',
    'underground-drill-rig': 'fas fa-cog',
    'utility-vehicles': 'fas fa-car',
    'underground-bev': 'fas fa-car-battery',
    'continuous-miners': 'fas fa-cogs',
    'construction-excavator': 'fas fa-cog',
    'construction-frontend-loader': 'fas fa-truck-loading',
    'construction-dump-truck': 'fas fa-truck-monster',
    'construction-dozer': 'fas fa-snowplow',
    'construction-grader': 'fas fa-road',
    'construction-water-truck': 'fas fa-tint',
    'construction-diesel-truck': 'fas fa-gas-pump',
    'construction-bobcat': 'fas fa-tractor',
    'construction-tlb': 'fas fa-tractor',
    'construction-crane': 'fas fa-angle-double-up',
    'construction-pecker-hammer': 'fas fa-hammer',
    'construction-boom-lift': 'fas fa-angle-double-up',
    'construction-wheel-tractorscraper': 'fas fa-tractor',
    'paver': 'fas fa-road',
    'construction-drill-rig': 'fas fa-cog',
    'construction-roller': 'fas fa-road',
    // Ore Sales
    'iron-ore': 'fas fa-magnet',
    'manganese': 'fas fa-atom',
    'chrome': 'fas fa-atom',
    'platinum': 'fas fa-ring',
    // Plant
    'mobile-jaw-crusher': 'fas fa-recycle',
    'screens': 'fas fa-th-large',
    'feeders': 'fas fa-exchange-alt',
    'mills': 'fas fa-sync-alt',
    'generators': 'fas fa-bolt',
    // Consumables
    'ppe': 'fas fa-user-shield',
    'tools': 'fas fa-tools',
    // Transportation
    'trucks': 'fas fa-truck',
    'trailers': 'fas fa-trailer',
    '45-cube-side-tipper-trailers': 'fas fa-truck-loading',
    '40-cube-side-tipper-trailers': 'fas fa-truck-loading',
    'flat-deck-trailers': 'fas fa-truck-plane',
    'tankers': 'fas fa-gas-pump',
    'low-bed': 'fas fa-truck-monster',
    // Generic 'Other' icons for each category
    'surface-equipment-other': 'fas fa-plus-circle',
    'plant-other': 'fas fa-plus-circle',
    'consumables-other': 'fas fa-plus-circle',
    'transportation-other': 'fas fa-plus-circle',
    // --- NEW: Icons for Miscellaneous categories ---
    'bearings': 'fas fa-cogs',
    'filters': 'fas fa-filter',
    'greases': 'fas fa-oil-can',
    'ball-bearings': 'far fa-circle',
    'diesel': 'fas fa-gas-pump',
    'roller-bearings': 'fas fa-bullseye',
    // --- NEW: Bearing Type Icons ---
    'pillow-blocks': 'fas fa-cubes',
    'automotive-bearing': 'fas fa-car',
    'radial-bearing': 'fas fa-circle-notch',
    'sleeve': 'fas fa-ring',
    'needle-roller-bearing': 'fas fa-ellipsis-v',
    'thrust-ball-bearing': 'fas fa-arrows-alt-v',
    'taper-roller-bearing': 'fas fa-caret-up',
    'spherical-roller-thrust-bearing': 'fas fa-bullseye',
    'miniature-ball-bearing': 'fas fa-dot-circle',
    'double-row-ball-bearing': 'fas fa-grip-lines',
    'kg-filters': 'fas fa-industry',
    'air-filter': 'fas fa-wind',
    'fuel-filter': 'fas fa-gas-pump',
    'hydraulic-filter': 'fas fa-cogs',
    'oil-filter': 'fas fa-oil-can',
    'air-dryer-filter': 'fas fa-tint-slash',
    'cabin-air-filter': 'fas fa-fan',
    'coolant-filter': 'fas fa-snowflake',
    'coolant-water-filter': 'fas fa-tint',
    'crankcase-ventilation-filter': 'fas fa-recycle',
    'air-oil-seperator-filter': 'fas fa-separator',
    'transmission-filter': 'fas fa-cogs',
    'fuel-filter-with-bowl': 'fas fa-filter',
    'fuel-filter-kit': 'fas fa-tools',
    'fuel-water-seperator': 'fas fa-water',
    'hyd-filter': 'fas fa-cogs',
    'hydraulic-filter-kit': 'fas fa-tools',
    'oil-filter-stratpore': 'fas fa-oil-can',
    'urea-filter': 'fas fa-vial',
    // --- NEW: Bearing Brands ---
    'kg-ultra': 'fas fa-industry', // Using a generic industry icon for brands
    'ntn': 'fas fa-industry',
    // --- NEW: Icons for PPE sub-categories ---
    'boots': 'fas fa-shoe-prints',
    'jackets': 'fas fa-tshirt',
    'gloves': 'fas fa-mitten',
    'pants': 'fas fa-user',
    'socks': 'fas fa-socks',
    'head-protection': 'fas fa-hard-hat',
    // --- NEW: Icons for Compressor Fleet Management ---
    'compressor-fleet-management': 'fas fa-wind',
    'new-screw-compressors': 'fas fa-cogs',
    'rotory-screw-airends': 'fas fa-fan',
    'compressor-parts': 'fas fa-tools',
    'service-kits': 'fas fa-box',
    'compressor-lubricant': 'fas fa-oil-can',
    // --- NEW: Icons for Additional Compressor Filters ---
    'new-compressors': 'fas fa-cogs',
    'refurbished-rotary-screw-compressor': 'fas fa-tools',
    'service-spare-parts': 'fas fa-box-open',
    'lubrication': 'fas fa-oil-can',
    'field-service': 'fas fa-wrench',
};
iconMap['kg-pps'] = 'fas fa-industry';
// --- NEW: Icons for Bearing Brands ---
iconMap['kg-ultra'] = 'fas fa-industry';
iconMap['ntn'] = 'fas fa-industry';
iconMap['fag'] = 'fas fa-industry';
const defaultIcon = 'fas fa-tag'; // A fallback icon

// Helper to get category ID by slug
const getCategoryIdBySlug = (categoriesArray, slug) => {
    const found = categoriesArray.find(c => c.slug === slug);
    return found ? found.id : null;
};

export default function CategoryFilter({ categories, selectedCategory, setSelectedCategory, searchTerm, setSearchTerm, allowedCategories, availableFacets, facets, onFacetChange, onClearAll, onStickyHeightChange, sortOption, setSortOption, totalItems, user, onShowLogin, onLogout, basketCount, savedItems, pageTitle, pageSubtitle }) {
    const location = useLocation();
    const navigate = useNavigate();
    // Hooks must be at the top level, outside of try/catch
    const [activeMainGroupId, setActiveMainGroupId] = React.useState(null);
    const [isMobileMenuOpen, setIsMobileMenuOpen] = React.useState(false);
    const [isAppMenuOpen, setIsAppMenuOpen] = React.useState(false);
    const [isScrolled, setIsScrolled] = React.useState(false);

    const searchBarRef = React.useRef(null);

    const [searchBarHeight, setSearchBarHeight] = React.useState(0);

    React.useEffect(() => {
        const resizeObserver = new ResizeObserver(entries => {
            for (let entry of entries) {
                if (entry.target === searchBarRef.current) {
                    setSearchBarHeight(entry.contentRect.height);
                }
            }
        });

        if (searchBarRef.current) resizeObserver.observe(searchBarRef.current);

        return () => {
            if (searchBarRef.current) resizeObserver.unobserve(searchBarRef.current);
        };
    }, []);

    React.useEffect(() => {
        if (onStickyHeightChange) onStickyHeightChange(searchBarHeight);
    }, [searchBarHeight, onStickyHeightChange]);

    React.useEffect(() => {
        const handleScroll = () => setIsScrolled(window.scrollY > 20);
        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    // --- Hook Logic: categoryGroups transformed outside of try block ---
    const categoryGroups = React.useMemo(() => {
        if (!categories || categories.length === 0) return [];
        
        let mainCategories;
        if (allowedCategories && allowedCategories.length > 0) {
            mainCategories = categories.filter(c => allowedCategories.includes(c.slug));
            
            // --- NEW: Inject missing required main categories ---
            // This ensures slugs like 'filters', 'conveyor-belts', etc. show up as headers
            // even if they don't exist exactly as top-level categories in the database.
            allowedCategories.forEach(slug => {
                if (!mainCategories.some(c => c.slug.toLowerCase() === slug.toLowerCase())) {
                    let name = slug.replace(/-/g, ' ').replace(/\b\w/g, l => l.toUpperCase());
                    if (slug === 'kg-pps') name = 'KG PPS';
                    if (slug === 'ppe') name = 'PPE';
                    if (slug === 'filters') name = 'Filters';
                    // Create a virtual main category
                    mainCategories.push({ id: `v_main_${slug}`, name, slug, parent_id: null, isVirtual: true });
                }
            });

            mainCategories.sort((a, b) => allowedCategories.indexOf(a.slug) - allowedCategories.indexOf(b.slug));
        } else {
            mainCategories = categories.filter(c => !c.parent_id);
        }

        // --- NEW: Helper to get subcategories including virtual ones ---
        const getSubcategories = (parent) => {
            // Get children from DB
            let l3s = categories.filter(c => c.parent_id === parent.id);

            // Inject virtual subcategories based on slug
            if (parent.slug === 'ppe') {
                const virtualPpeSubs = [
                    { id: `v_boots_${parent.id}`, name: 'Boots', slug: 'boots', parent_id: parent.id, isVirtual: true },
                    { id: `v_jackets_${parent.id}`, name: 'Jackets', slug: 'jackets', parent_id: parent.id, isVirtual: true },
                    { id: `v_gloves_${parent.id}`, name: 'Gloves', slug: 'gloves', parent_id: parent.id, isVirtual: true },
                    { id: `v_pants_${parent.id}`, name: 'Pants', slug: 'pants', parent_id: parent.id, isVirtual: true },
                    { id: `v_socks_${parent.id}`, name: 'Socks', slug: 'socks', parent_id: parent.id, isVirtual: true },
                    { id: `v_head-protection_${parent.id}`, name: 'Head Protection', slug: 'head-protection', parent_id: parent.id, isVirtual: true },
                ];
                virtualPpeSubs.forEach(vSub => {
                    if (!l3s.some(existing => existing.slug === vSub.slug)) l3s.push(vSub);
                });
            }

            // --- NEW: Bearing Hierarchy ---
            // Level 2: Bearings -> Types
            if (parent.slug === 'bearings' || parent.slug === 'roller-bearings' || parent.slug === 'ball-bearings') {
                // Types
                const types = [
                    { id: `v_pb_${parent.id}`, name: 'Pillow Blocks', slug: 'pillow-blocks', parent_id: parent.id, isVirtual: true },
                    { id: `v_cr_${parent.id}`, name: 'Cylindrical Roller', slug: 'cylindrical-roller-bearing', parent_id: parent.id, isVirtual: true },
                    { id: `v_sr_${parent.id}`, name: 'Spherical Roller', slug: 'spherical-roller-bearing', parent_id: parent.id, isVirtual: true },
                    { id: `v_tr_${parent.id}`, name: 'Taper Roller', slug: 'taper-roller-bearing', parent_id: parent.id, isVirtual: true },
                    { id: `v_dg_${parent.id}`, name: 'Deep Groove Ball', slug: 'single-row-deep-groove-ball-bearing', parent_id: parent.id, isVirtual: true },
                    { id: `v_ac_${parent.id}`, name: 'Angular Contact Ball', slug: 'double-row-angular-contact-ball-bearing', parent_id: parent.id, isVirtual: true },
                    { id: `v_sa_${parent.id}`, name: 'Self-Aligning Ball', slug: 'self-aligning-ball-bearing', parent_id: parent.id, isVirtual: true },
                    { id: `v_tb_${parent.id}`, name: 'Thrust Ball', slug: 'thrust-ball-bearing', parent_id: parent.id, isVirtual: true },
                    { id: `v_nr_${parent.id}`, name: 'Needle Roller', slug: 'needle-roller-bearing', parent_id: parent.id, isVirtual: true },
                    { id: `v_ab_${parent.id}`, name: 'Automotive', slug: 'automotive-bearing', parent_id: parent.id, isVirtual: true },
                    { id: `v_rb_${parent.id}`, name: 'Radial', slug: 'radial-bearing', parent_id: parent.id, isVirtual: true },
                    { id: `v_sl_${parent.id}`, name: 'Sleeve', slug: 'sleeve', parent_id: parent.id, isVirtual: true },
                    { id: `v_mb_${parent.id}`, name: 'Miniature Ball', slug: 'miniature-ball-bearing', parent_id: parent.id, isVirtual: true },
                    { id: `v_dr_${parent.id}`, name: 'Double Row Ball', slug: 'double-row-ball-bearing', parent_id: parent.id, isVirtual: true }
                ];
                types.forEach(vSub => {
                    if (!l3s.some(existing => existing.slug === vSub.slug)) l3s.push(vSub);
                });
            }

            // Level 3: Bearing Type -> Brands
            const bearingTypeSlugs = [
                'pillow-blocks', 'cylindrical-roller-bearing', 'spherical-roller-bearing', 
                'taper-roller-bearing', 'single-row-deep-groove-ball-bearing', 
                'double-row-angular-contact-ball-bearing', 'self-aligning-ball-bearing', 
                'thrust-ball-bearing', 'needle-roller-bearing', 'automotive-bearing', 
                'radial-bearing', 'sleeve', 'miniature-ball-bearing', 'double-row-ball-bearing'
            ];
            if (bearingTypeSlugs.includes(parent.slug)) {
                l3s.push({ id: `v_br_kg_${parent.id}`, name: 'KG Ultra', slug: `kg-${parent.slug}`, parent_id: parent.id, isVirtual: true });
                l3s.push({ id: `v_br_ntn_${parent.id}`, name: 'NTN', slug: `ntn-${parent.slug}`, parent_id: parent.id, isVirtual: true });
                l3s.push({ id: `v_br_fag_${parent.id}`, name: 'FAG', slug: `fag-${parent.slug}`, parent_id: parent.id, isVirtual: true });
            }

            // --- NEW: Filter Hierarchy ---
            if (parent.slug === 'filters') {
                const filterTypes = [
                    { id: `v_f_air_${parent.id}`, name: 'Air Filter', slug: 'air-filter', parent_id: parent.id, isVirtual: true },
                    { id: `v_f_fuel_${parent.id}`, name: 'Fuel Filter', slug: 'fuel-filter', parent_id: parent.id, isVirtual: true },
                    { id: `v_f_hyd_${parent.id}`, name: 'Hydraulic Filter', slug: 'hydraulic-filter', parent_id: parent.id, isVirtual: true },
                    { id: `v_f_oil_${parent.id}`, name: 'Oil Filter', slug: 'oil-filter', parent_id: parent.id, isVirtual: true },
                    { id: `v_f_kg_${parent.id}`, name: 'KG Filters (Brand)', slug: 'kg-filters', parent_id: parent.id, isVirtual: true },
                ];
                filterTypes.forEach(vSub => {
                    if (!l3s.some(existing => existing.slug === vSub.slug)) l3s.push(vSub);
                });
            }

            if (parent.slug === 'conveyor-belts') {
                l3s.push({ id: `v_c_arb_${parent.id}`, name: 'ARB (Brand)', slug: 'arb-conveyors', parent_id: parent.id, isVirtual: true });
                l3s.push({ id: `v_c_textile_${parent.id}`, name: 'Textile Rubber', slug: 'textile-rubber-conveyor', parent_id: parent.id, isVirtual: true });
            }

            return l3s;
        };

        return mainCategories.map(main => {
            // Get second-level subcategories
            let level2 = getSubcategories(main);

            // Map third-level subcategories onto second-level
            const subsWithL3 = level2.map(sub => {
                return { ...sub, subcategories: getSubcategories(sub) };
            });

            return { ...main, subcategories: subsWithL3 };
        });
    }, [categories, allowedCategories]);

    // --- NEW: Create page-specific filter pills array ---
    // This ensures filter pills only show main categories for the current page
    const filterPillCategories = React.useMemo(() => {
        if (!categories || categories.length === 0) return [];
        
        if (allowedCategories && allowedCategories.length > 0) {
            // For pages with specific allowed categories (like Miscellaneous)
            let pillCategories = [];
            
            allowedCategories.forEach(slug => {
                // Find the category in the database
                let category = categories.find(c => c.slug === slug);
                
                if (category) {
                    pillCategories.push(category);
                } else {
                    // Create virtual category if not found in database
                    let name = slug.replace(/-/g, ' ').replace(/\b\w/g, l => l.toUpperCase());
                    if (slug === 'kg-pps') name = 'KG PPS';
                    if (slug === 'ppe') name = 'PPE';
                    if (slug === 'filters') name = 'Filters';
                    if (slug === 'diesel') name = 'Diesel';
                    
                    pillCategories.push({
                        id: `v_main_${slug}`,
                        name,
                        slug,
                        parent_id: null,
                        isVirtual: true
                    });
                }
            });

            // Sort according to allowedCategories order
            pillCategories.sort((a, b) => allowedCategories.indexOf(a.slug) - allowedCategories.indexOf(b.slug));
            return pillCategories;
        } else {
            // For pages without restrictions, show all top-level categories
            return categories.filter(c => !c.parent_id);
        }
    }, [categories, allowedCategories]);

    try {
        const isEquipmentContext = ['surface-equipment', 'underground-equipment', 'construction-equipment', 'plant', 'rebuilds', 'rentals'].some(slug => 
            selectedCategory === slug || (allowedCategories && allowedCategories.includes(slug))
        );

        return (
            <React.Fragment>
                <div ref={searchBarRef} className="sticky top-0 z-50 bg-white/70 backdrop-blur-lg border-b border-gray-200/50 shadow-sm transition-all duration-300">
                    <div className="container mx-auto px-4 pt-0 pb-0">
                        {/* Top Action Row: Filters and Sort */}
                        <div className="flex items-center justify-between mb-2 gap-2">
                            <div className="flex items-center gap-2">
                                {/* Brand Logo */}
                                <img 
                                    src="images/logo/MM Logo.jpg" 
                                    alt="Logo" 
                                    className="h-9 w-9 rounded-lg cursor-pointer shadow-sm border border-gray-200" 
                                    onClick={() => navigate('/')}
                                />
                                
                                <button
                                    onClick={() => setIsMobileMenuOpen(true)}
                                    className="flex items-center gap-2 px-3 py-1 bg-gray-100 hover:bg-gray-200 text-gray-900 rounded-full border border-gray-200 transition-colors"
                                >
                                    <span className="text-[10px] md:text-xs font-black uppercase tracking-widest">Filters</span>
                                    {selectedCategory !== 'all' && (
                                        <span className="w-2 h-2 bg-blue-600 rounded-full"></span>
                                    )}
                                </button>
                            </div>

                            <div className="flex items-center gap-3">
                                <div className="hidden sm:flex items-center gap-1 text-gray-900 border-r border-gray-200 pr-3">
                                    <span className="text-[10px] font-black uppercase tracking-widest">Sort</span>
                                    <select 
                                        value={sortOption} 
                                        onChange={(e) => setSortOption(e.target.value)}
                                        className="bg-transparent text-xs font-black text-blue-600 focus:outline-none cursor-pointer appearance-none pr-6 relative uppercase tracking-tighter"
                                        style={{ backgroundImage: 'url("data:image/svg+xml,%3Csvg xmlns=\'http://www.w3.org/2000/svg\' viewBox=\'0 0 24 24\' fill=\'none\' stroke=\'%232563EB\' stroke-width=\'2\' stroke-linecap=\'round\' stroke-linejoin=\'round\'%3E%3Cpolyline points=\'6 9 12 15 18 9\'%3E%3C/polyline%3E%3C/svg%3E")', backgroundRepeat: 'no-repeat', backgroundPosition: 'right 4px center', backgroundSize: '12px' }}
                                    >
                                        <option value="date_desc">Newest</option>
                                        <option value="date_asc">Oldest</option>
                                        <option value="price_asc">Price: Low to High</option>
                                        <option value="price_desc">Price: High to Low</option>
                                        {isEquipmentContext && (
                                            <>
                                                <option value="hours_asc">Hours: Least to Most</option>
                                                <option value="hours_desc">Hours: Most to Least</option>
                                            </>
                                        )}
                                    </select>
                                </div>

                                <div className="flex items-center gap-2">
                                    <NotificationBell user={user} onShowLogin={onShowLogin} className="text-gray-900" />
                                    
                                    {/* Saved Items Link (Heart Icon) */}
                                    {user && (
                                        <button 
                                            onClick={() => navigate('/saved-items')} 
                                            className={`p-1 transition-colors ${location.pathname.includes('/saved-items') ? 'text-red-500' : 'text-gray-900 hover:text-red-500'}`}
                                            title="My Saved Items"
                                        >
                                            <div className="relative">
                                                <i className="fas fa-heart text-lg"></i>
                                                {savedItems && savedItems.length > 0 && (
                                                    <span className="absolute -top-1 -right-1 bg-red-600 text-white text-[9px] font-bold w-4 h-4 rounded-full flex items-center justify-center border border-white">
                                                        {savedItems.length}
                                                    </span>
                                                )}
                                            </div>
                                        </button>
                                    )}

                                    {/* Basket Icon */}
                                    <button onClick={() => navigate('/basket', { state: { from: location.pathname } })} className="relative text-gray-900 hover:text-blue-600 p-1 md:ml-2">
                                        <i className="fas fa-shopping-basket text-[16px]"></i>
                                        {basketCount > 0 && (
                                            <span className="absolute -top-1 -right-1 bg-red-600 text-white text-[9px] font-bold w-4 h-4 rounded-full flex items-center justify-center border-2 border-white">
                                                {basketCount}
                                            </span>
                                        )}
                                    </button>

                                    {user ? (
                                        <div className="hidden sm:flex items-center space-x-2 px-3 py-2 rounded-lg bg-gray-100">
                                            <i className="fas fa-user-circle text-blue-600"></i>
                                            <span className="text-sm font-medium text-gray-900">{user.firstname || user.name || 'User'}</span>
                                            <span className="text-xs bg-blue-600 text-white px-2 py-1 rounded-full">
                                                {user.activeRole || 'buyer'}
                                            </span>
                                        </div>
                                    ) : (
                                        <button onClick={onShowLogin} className="text-[10px] md:text-xs font-bold text-gray-900 uppercase hover:underline">Login</button>
                                    )}

                                    {/* Desktop App Menu Hamburger */}
                                    <button onClick={() => setIsAppMenuOpen(true)} className="hidden md:block p-1 text-gray-900 hover:text-blue-600 transition-colors">
                                        <i className="fas fa-bars text-xl"></i>
                                    </button>
                                </div>
                            </div>
                        </div>

                        {/* Search Row */}
                        <form onSubmit={(e) => { e.preventDefault(); document.activeElement.blur(); }} className="relative mb-1">
                            <input
                                type="text"
                                placeholder="Search equipment, parts, services..."
                                value={searchTerm}
                                onChange={(e) => setSearchTerm(e.target.value)}
                                className="w-full bg-gray-50 border border-gray-200 focus:bg-white focus:border-blue-500 rounded-lg py-2 pl-4 pr-10 text-sm focus:outline-none transition-all placeholder:text-gray-900 text-gray-900"
                            />
                            <div className="absolute right-3 top-1/2 -translate-y-1/2 flex items-center gap-2">
                                {searchTerm && ( // Clear button
                                    <button type="button" onClick={onClearAll} className="text-gray-900 hover:text-gray-600">
                                        <i className="fas fa-times-circle text-xs"></i>
                                    </button>
                                )}
                                <i className="fas fa-search text-gray-900 text-xs"></i>
                            </div>
                        </form>

                        {/* Header underneath search bar */}
                        {(pageTitle || pageSubtitle) && (
                            <div className="px-1 animate-fade-in">
                                {pageTitle && <h1 className="text-2xl md:text-3xl font-black text-gray-900 tracking-tighter uppercase leading-none">{pageTitle}</h1>}
                                {pageSubtitle && <p className="text-[10px] font-bold text-blue-600 uppercase tracking-[0.2em] mt-1">{pageSubtitle}</p>}
                            </div>
                        )}

                        {/* Quick Access Filters (Horizontal Scroll) */}
                        <div className="flex items-center gap-3">
                            <div className="flex-shrink-0 border-r border-gray-200 pr-2 mr-1">
                                <span className="text-[9px] text-gray-900 font-black uppercase tracking-widest whitespace-nowrap">
                                    {totalItems ? `${totalItems.toLocaleString()} items` : 'Searching...'}
                                </span>
                            </div>
                            <div className="flex overflow-x-auto gap-2 pb-0 no-scrollbar mask-fade-right">
                                {/* Hide "All" button for Miscellaneous page since it doesn't work correctly */}
                                {!allowedCategories?.includes('miscellaneous') && (
                                <button
                                    onClick={() => setSelectedCategory('all')}
                                    className={`px-3 py-1 rounded-full text-[10px] font-black uppercase tracking-widest whitespace-nowrap transition-all ${selectedCategory === 'all' ? 'bg-blue-600 text-white shadow-sm' : 'bg-white border border-gray-200 text-gray-900 hover:border-blue-300'}`}
                                >
                                    All
                                </button>
                                )}
                                {filterPillCategories.map(category => (
                                    <button 
                                        key={category.id}
                                        onClick={() => setSelectedCategory(category.slug)}
                                        className={`px-3 py-1 rounded-full text-[10px] font-black uppercase tracking-widest whitespace-nowrap transition-all ${selectedCategory === category.slug ? 'bg-blue-600 text-white shadow-sm' : 'bg-white border border-gray-200 text-gray-900 hover:border-blue-300'}`}
                                    >
                                        {category.name}
                                    </button>
                                ))}
                            </div>
                        </div>
                    </div>
                </div>

                {/* Sidebar Filter Menu (Slide-in) */}
                {isMobileMenuOpen && (
                    <div className="fixed inset-0 z-[9999] flex justify-end">
                        <div className="absolute inset-0 bg-black/30 backdrop-blur-sm transition-opacity" onClick={() => setIsMobileMenuOpen(false)}></div>
                        <div className="relative w-4/5 max-w-[400px] bg-white/70 backdrop-blur-xl h-full shadow-2xl flex flex-col transform transition-transform duration-300 animate-slide-in-right overflow-hidden border-l border-white/20">
                            <div className="p-4 border-b flex justify-between items-center bg-white sticky top-0 z-10">
                                <h2 className="text-lg font-bold text-gray-900">Filters</h2>
                                <button onClick={() => setIsMobileMenuOpen(false)} className="text-gray-900 p-2"><i className="fas fa-times text-2xl"></i></button>
                            </div>
                            <div className="p-4 overflow-y-auto flex-grow space-y-6">
                                {/* Hide "All Products" button for Miscellaneous page since it doesn't work correctly */}
                                {!allowedCategories?.includes('miscellaneous') && (
                                <button onClick={() => { setSelectedCategory('all'); setIsMobileMenuOpen(false); }} className={`w-full text-left p-3 rounded-lg font-black uppercase tracking-widest flex items-center gap-3 ${selectedCategory === 'all' ? 'bg-blue-600 text-white shadow-md' : 'bg-gray-100 text-gray-900'}`}>
                                    <i className="fas fa-th-large"></i> All Products
                                </button>
                                )}
                                
                                <div className="space-y-4">
                                    <h3 className="text-[10px] font-black text-gray-900 uppercase tracking-[0.3em] px-1">Marketplace Categories</h3>
                                {categoryGroups.map(group => (
                                    <div key={group.id} className="space-y-3">
                                            {/* Level 1: Main Categories */}
                                            <button 
                                                onClick={() => { 
                                                    setSelectedCategory(group.slug); 
                                                    setActiveMainGroupId(activeMainGroupId === group.id ? null : group.id); 
                                                }} 
                                                className={`w-full text-left p-3 rounded-lg font-bold flex items-center gap-3 border transition-all ${selectedCategory === group.slug || activeMainGroupId === group.id ? 'bg-blue-50 text-blue-700 border border-blue-200' : 'bg-white text-gray-900 border-gray-300 hover:bg-gray-100 hover:border-gray-400'}`}
                                            >
                                            <i className={iconMap[group.slug] || defaultIcon}></i> {group.name}
                                        </button>
                                        {(activeMainGroupId === group.id || selectedCategory === group.slug) && group.subcategories.length > 0 && (
                                            <div className="grid grid-cols-1 gap-2 pl-4 border-l-2 border-blue-100">
                                                {group.subcategories.map(sub => {
                                                    // Level 2 logic: Active if selected OR if one of its brands is selected
                                                    const isSubActive = selectedCategory === sub.slug || (sub.subcategories && sub.subcategories.some(l3 => l3.slug === selectedCategory));
                                                    return (
                                                        <React.Fragment key={sub.id}>
                                                            <button 
                                                                onClick={() => { 
                                                                    setSelectedCategory(sub.slug);
                                                                    if (sub.subcategories.length === 0) setIsMobileMenuOpen(false);
                                                                }} 
                                                                className={`text-left p-3 rounded-lg text-sm font-medium border transition-all ${isSubActive ? 'bg-blue-600 text-white border-blue-700' : 'bg-white text-gray-900 border-gray-300 hover:bg-gray-100 hover:border-gray-400'}`}
                                                            >
                                                                {sub.name}
                                                            </button>
                                                            {isSubActive && sub.subcategories && sub.subcategories.length > 0 && (
                                                                <div className="grid grid-cols-1 gap-1 pl-4 border-l border-blue-200 ml-2">
                                                                    {sub.subcategories.map(l3 => (
                                                                        <button 
                                                                            key={l3.id} 
                                                                            onClick={() => { setSelectedCategory(l3.slug); setIsMobileMenuOpen(false); }}
                                                                            className={`text-left p-2 rounded text-xs border transition-all ${selectedCategory === l3.slug ? 'bg-blue-100 text-blue-700 font-bold border-blue-300' : 'bg-white text-gray-900 border-gray-300 hover:bg-gray-100 hover:border-gray-400'}`}
                                                                        >
                                                                            {l3.name}
                                                                        </button>
                                                                    ))}
                                                                </div>
                                                            )}
                                                        </React.Fragment>
                                                    );
                                                })}
                                            </div>
                                        )}
                                    </div>
                                ))}
                                </div>
                            </div>
                            <div className="p-6 border-t bg-gray-50">
                                <button onClick={() => setIsMobileMenuOpen(false)} className="w-full primary-gradient text-white py-3 rounded-xl font-bold shadow-lg">Show Results</button>
                            </div>
                        </div>
                    </div>
                )}

                {/* App Navigation Sidebar (Slide-in) */}
                {isAppMenuOpen && (
                    <div className="fixed inset-0 z-[9999] flex justify-end">
                        <div className="absolute inset-0 bg-black/30 backdrop-blur-sm transition-opacity" onClick={() => setIsAppMenuOpen(false)}></div>
                        <div className="relative w-4/5 max-w-[400px] bg-white/70 backdrop-blur-xl h-full shadow-2xl flex flex-col transform transition-transform duration-300 animate-slide-in-right overflow-hidden border-l border-white/20">
                            <div className="p-4 border-b flex justify-between items-center bg-white sticky top-0 z-10">
                                <h2 className="text-lg font-bold text-gray-900">Application Menu</h2>
                                <button onClick={() => setIsAppMenuOpen(false)} className="text-gray-900 p-2"><i className="fas fa-times text-2xl"></i></button>
                            </div>
                            <div className="p-4 overflow-y-auto flex-grow space-y-2">
                                <Link to="/" onClick={() => setIsAppMenuOpen(false)} className="flex items-center gap-3 p-3 rounded-lg hover:bg-gray-100 text-gray-900 font-bold transition-colors"><i className="fas fa-home w-6"></i> Home</Link>
                                <Link to="/equipment" onClick={() => setIsAppMenuOpen(false)} className="flex items-center gap-3 p-3 rounded-lg hover:bg-gray-100 text-gray-900 font-bold transition-colors"><i className="fas fa-truck-monster w-6"></i> Equipment</Link>
                                <Link to="/consumables" onClick={() => setIsAppMenuOpen(false)} className="flex items-center gap-3 p-3 rounded-lg hover:bg-gray-100 text-gray-900 font-bold transition-colors"><i className="fas fa-box-open w-6"></i> Consumables</Link>
                                <Link to="/miscellaneous" onClick={() => setIsAppMenuOpen(false)} className="flex items-center gap-3 p-3 rounded-lg hover:bg-gray-100 text-gray-900 font-bold transition-colors"><i className="fas fa-circle-notch w-6"></i> Miscellaneous</Link>
                                <Link to="/rebuilds" onClick={() => setIsAppMenuOpen(false)} className="flex items-center gap-3 p-3 rounded-lg hover:bg-gray-100 text-gray-900 font-bold transition-colors"><i className="fas fa-tools w-6"></i> Rebuilds</Link>
                                <Link to="/rentals" onClick={() => setIsAppMenuOpen(false)} className="flex items-center gap-3 p-3 rounded-lg hover:bg-gray-100 text-gray-900 font-bold transition-colors"><i className="fas fa-clock w-6"></i> Rentals</Link>
                                <Link to="/commercial" onClick={() => setIsAppMenuOpen(false)} className="flex items-center gap-3 p-3 rounded-lg hover:bg-gray-100 text-gray-900 font-bold transition-colors"><i className="fas fa-briefcase w-6"></i> Commercial</Link>
                                <Link to="/components-and-spares" onClick={() => setIsAppMenuOpen(false)} className="flex items-center gap-3 p-3 rounded-lg hover:bg-gray-100 text-gray-900 font-bold transition-colors"><i className="fas fa-cogs w-6"></i> Components</Link>
                                <Link to="/financeform" onClick={() => setIsAppMenuOpen(false)} className="flex items-center gap-3 p-3 rounded-lg hover:bg-gray-100 text-green-600 font-bold transition-colors"><i className="fas fa-hand-holding-usd w-6"></i> Financing</Link>
                                <Link to="/kp-insurance" onClick={() => setIsAppMenuOpen(false)} className="flex items-center gap-3 p-3 rounded-lg hover:bg-gray-100 text-red-600 font-bold transition-colors"><i className="fas fa-shield-alt w-6"></i> King Price Insurance</Link>
                                 <Link to="/sheq" onClick={() => setIsAppMenuOpen(false)} className="flex items-center gap-3 p-3 rounded-lg hover:bg-gray-100 text-purple-600 font-bold transition-colors"><i className="fas fa-shield-alt w-6"></i> SHEQ Services</Link>
                                 <Link to="/drill-catalog" onClick={() => setIsAppMenuOpen(false)} className="flex items-center gap-3 p-3 rounded-lg hover:bg-gray-100 text-orange-600 font-bold transition-colors"><i className="fas fa-drill w-6"></i> Drill Catalog</Link>
                                 <Link to="/labour" onClick={() => setIsAppMenuOpen(false)} className="flex items-center gap-3 p-3 rounded-lg hover:bg-gray-100 text-green-600 font-bold transition-colors"><i className="fas fa-users w-6"></i> Labour</Link>
                                 <div className="border-t my-2"></div>
                                {user && <Link to="/dashboard" onClick={() => setIsAppMenuOpen(false)} className="flex items-center gap-3 p-3 rounded-lg hover:bg-gray-100 text-gray-900 font-bold transition-colors"><i className="fas fa-tachometer-alt w-6"></i> Dashboard</Link>}
                                {user && <Link to="/profile" onClick={() => setIsAppMenuOpen(false)} className="flex items-center gap-3 p-3 rounded-lg hover:bg-gray-100 text-gray-900 font-bold transition-colors"><i className="fas fa-user-circle w-6"></i> Profile</Link>}
                                {!user && <button onClick={() => { setIsAppMenuOpen(false); onShowLogin(); }} className="w-full text-left flex items-center gap-3 p-3 rounded-lg hover:bg-blue-50 text-blue-600 font-bold transition-colors"><i className="fas fa-sign-in-alt w-6"></i> Login / Sign Up</button>}
                                {user && (
                                    <button 
                                        onClick={() => { onLogout(); setIsAppMenuOpen(false); }} 
                                        className="w-full text-left flex items-center gap-3 p-3 rounded-lg hover:bg-red-50 text-red-600 font-bold transition-colors"
                                    >
                                        <i className="fas fa-sign-out-alt w-6"></i> Logout
                                    </button>
                                )}
                            </div>
                        </div>
                    </div>
                )}
            </React.Fragment>
        );
    } catch (error) {
        console.error('CategoryFilter component error:', error);
        return <div>Error loading filters</div>;
    }
}
